var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8128)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_8128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0019 49.0273C23.3756 49.0276 21.7534 48.864 20.1599 48.539C17.0867 47.9095 14.1675 46.6811 11.569 44.9238C7.70622 42.3163 4.68257 38.6444 2.86438 34.3533C2.2501 32.8999 1.78125 31.3891 1.46468 29.8433C0.813858 26.6481 0.813858 23.3545 1.46468 20.1593C2.094 17.0861 3.32239 14.167 5.07972 11.5685C7.68733 7.70578 11.3591 4.68217 15.6502 2.86389C17.1036 2.24978 18.6142 1.78102 20.16 1.46447C23.3552 0.813928 26.6488 0.813928 29.844 1.46447C32.9172 2.09393 35.8363 3.32233 38.4349 5.07965C42.2976 7.68719 45.3212 11.3589 47.1395 15.65C47.7539 17.1034 48.2228 18.6141 48.5394 20.1599C49.1902 23.3551 49.1902 26.6487 48.5394 29.8439C47.91 32.9171 46.6816 35.8362 44.9244 38.4348C42.3168 42.2975 38.645 45.3213 34.3538 47.1395C32.9004 47.7538 31.3898 48.2228 29.844 48.5395C28.2504 48.8644 26.6282 49.0277 25.0019 49.0273ZM30.3105 11.4222C28.6389 11.4232 26.9923 11.8285 25.5111 12.6036C24.03 13.3786 22.7583 14.5004 21.8045 15.8731C20.8507 17.2459 20.243 18.829 20.0333 20.4874C19.8236 22.1458 20.0181 23.8305 20.6002 25.3975L11.4205 34.5772V40.671H17.5143V37.0148H21.1703V33.3586H24.8264L26.6939 31.4909C28.1146 32.0202 29.6341 32.2312 31.1453 32.1091C32.6565 31.9869 34.1224 31.5345 35.4397 30.7838C36.7569 30.0332 37.8933 29.0027 38.7688 27.7649C39.6442 26.5271 40.2373 25.1123 40.5062 23.6202C40.7752 22.1282 40.7133 20.5953 40.3251 19.1298C39.9369 17.6642 39.2317 16.3017 38.2594 15.1384C37.2871 13.9752 36.0713 13.0394 34.6979 12.3974C33.3245 11.7553 31.8269 11.4226 30.3108 11.4225L30.3105 11.4222ZM32.7478 22.3902C31.9951 22.3891 31.2696 22.1087 30.7121 21.603C30.1545 21.0973 29.8047 20.4025 29.7304 19.6535C29.6561 18.9045 29.8626 18.1545 30.3099 17.5491C30.7573 16.9438 31.4135 16.5262 32.1513 16.3773C32.8891 16.2283 33.656 16.3588 34.3031 16.7433C34.9502 17.1278 35.4314 17.7388 35.6535 18.458C35.8755 19.1772 35.8225 19.9533 35.5047 20.6356C35.187 21.318 34.6271 21.8579 33.9337 22.1508C33.5585 22.3095 33.1551 22.391 32.7478 22.3902Z",
    fill: "url(#paint0_linear_27_8128)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_8128",
    x: -15.0234,
    y: -15.0234,
    width: 70.0508,
    height: 70.0508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.251 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_8128",
    x1: 9.91404,
    y1: 7.1751,
    x2: 42.156,
    y2: 41.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword1);
export default __webpack_public_path__ + "static/media/change-password – 1.d9c09e8fe0abf3f3e0808a7e4e6b55ff.svg";
export { ForwardRef as ReactComponent };